(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["favoritos-button"] && !Shopify.designMode) return;
  try {
    const ENDPOINT = "/apps/avise-me/register";
  const SELECTOR = "[data-favoritos-card]";
  const BOUND_ATTR = "data-favoritos-bound";
  let favoritesCache = null;
  let hydrateInFlight = null;
  let observerTimer = 0;

  function productGid(root) {
    return root.dataset.productId ? `gid://shopify/Product/${root.dataset.productId}` : "";
  }

  function setFavorited(button, isFav) {
    button.classList.toggle("is-favorited", isFav);
    button.setAttribute("aria-pressed", isFav ? "true" : "false");
  }

  function syncProduct(productId, isFav) {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.dataset.productId !== productId) return;
      const button = root.querySelector(".favoritos-heart-button");
      if (button instanceof HTMLButtonElement) setFavorited(button, isFav);
    });
  }

  function applyCache(roots) {
    if (!Array.isArray(favoritesCache)) return;
    const set = new Set(favoritesCache);
    roots.forEach((root) => {
      const button = root.querySelector(".favoritos-heart-button");
      const gid = productGid(root);
      if (button instanceof HTMLButtonElement && gid) setFavorited(button, set.has(gid));
    });
  }

  async function hydrate(roots) {
    const hasCustomer = Array.from(roots).some((root) => root.dataset.customerId);
    if (!hasCustomer || hydrateInFlight) return hydrateInFlight;
    hydrateInFlight = (async () => {
      try {
        const response = await fetch(ENDPOINT, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) return;
        const body = await response.json();
        if (!body || body.ok === false || !Array.isArray(body.favorites)) return;
        favoritesCache = body.favorites;
        applyCache(document.querySelectorAll(SELECTOR));
      } catch {
      } finally {
        hydrateInFlight = null;
      }
    })();
    return hydrateInFlight;
  }

  function bindRoot(root) {
    if (root.getAttribute(BOUND_ATTR) === "true") return;
    const button = root.querySelector(".favoritos-heart-button");
    const status = root.querySelector(".favoritos-status");
    if (!(button instanceof HTMLButtonElement) || !(status instanceof HTMLElement)) return;
    root.setAttribute(BOUND_ATTR, "true");

    const labels = {
      add: root.dataset.labelAdd || "Adicionado aos favoritos.",
      remove: root.dataset.labelRemove || "Removido dos favoritos.",
      login: root.dataset.labelLogin || "Faça login para salvar favoritos.",
      saving: root.dataset.labelSaving || "Salvando...",
      error: root.dataset.labelError || "Não foi possível salvar o favorito.",
    };

    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const customerId = root.dataset.customerId || "";
      const loginUrl = root.dataset.loginUrl || "/account/login";
      const productId = root.dataset.productId || "";

      if (!customerId) {
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `${loginUrl}?return_url=${returnUrl}`;
        return;
      }

      if (!productId) {
        status.textContent = labels.error;
        return;
      }

      button.disabled = true;
      status.textContent = labels.saving;

      try {
        const response = await fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ productId }),
        });
        const contentType = response.headers.get("content-type") || "";
        const body = contentType.includes("application/json") ? await response.json() : null;

        if (!response.ok || !body || body.ok === false) {
          throw new Error((body && body.error) || labels.error);
        }

        const removed = body.action === "removed";
        const gid = productGid(root);
        if (Array.isArray(favoritesCache) && gid) {
          favoritesCache = removed
            ? favoritesCache.filter((id) => id !== gid)
            : favoritesCache.concat(gid);
        }
        syncProduct(productId, !removed);
        status.textContent = removed ? labels.remove : labels.add;
      } catch (error) {
        status.textContent = error instanceof Error && error.message ? error.message : labels.error;
      } finally {
        button.disabled = false;
      }
    });
  }

  function init() {
    const unbound = document.querySelectorAll(`${SELECTOR}:not([${BOUND_ATTR}])`);
    if (!unbound.length) return;
    unbound.forEach(bindRoot);
    const roots = document.querySelectorAll(SELECTOR);
    if (Array.isArray(favoritesCache)) applyCache(unbound);
    else hydrate(roots);
  }

  init();
  const observer = new MutationObserver(() => {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(init, 80);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCarousel(wrapper) {
      const track = wrapper.querySelector('.mobile-carousel__track');
      const dotsContainer = wrapper.querySelector('.mobile-carousel__dots');
      if (!track || !dotsContainer) return;

      const slides = () => Array.from(track.children);

      // Build dots
      function buildDots() {
        const s = slides();
        if (s.length <= 1) return;
        dotsContainer.innerHTML = '';
        s.forEach((_, i) => {
          const btn = document.createElement('button');
          btn.className = 'mobile-carousel__dot';
          btn.setAttribute('aria-label', `Slide ${i + 1}`);
          btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          btn.addEventListener('click', () => {
            const target = slides()[i];
            if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          });
          dotsContainer.appendChild(btn);
        });
      }

      function currentIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function updateDots(index) {
        dotsContainer.querySelectorAll('.mobile-carousel__dot').forEach((dot, i) => {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      let timer;
      track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => updateDots(currentIndex()), 50);
      }, { passive: true });

      buildDots();
    }

    // Only initialise on mobile — avoids any side-effects on desktop
    function maybeInit() {
      if (window.innerWidth > 749) return;
      document.querySelectorAll('.section-content-wrapper--carousel').forEach(initCarousel);
    }

    // Run on load and on resize (debounced)
    document.addEventListener('DOMContentLoaded', maybeInit);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(maybeInit, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
